var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSynthiaiChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Asset 7 1"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_461_2736)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M42.0692 32.8815C43.9384 29.5103 45.0056 25.6308 45.0056 21.5028C45 8.52036 34.4796 -2 21.5028 -2C8.53166 -2 -2 8.53166 -2 21.5028C-2 34.4796 8.52036 45.0056 21.5028 45.0056C25.8058 45.0056 29.8378 43.848 33.3051 41.832L41.7869 44.4353C43.5826 44.9887 45.2711 43.3059 44.7177 41.5045L42.0692 32.8815Z",
    fill: "url(#paint0_linear_461_2736)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.2704 13.0662C23.2704 12.09 22.479 11.2987 21.5029 11.2987C20.5267 11.2987 19.7354 12.09 19.7354 13.0662V29.9395C19.7354 30.9156 20.5267 31.707 21.5029 31.707C22.479 31.707 23.2704 30.9156 23.2704 29.9395V13.0662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.6971 16.3923C15.6971 15.4161 14.9058 14.6248 13.9296 14.6248C12.9535 14.6248 12.1621 15.4161 12.1621 16.3923V25.8115C12.1621 26.7876 12.9535 27.579 13.9296 27.579C14.9058 27.579 15.6971 26.7876 15.6971 25.8115V16.3923Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.12487 19.2553C8.12487 18.2791 7.33353 17.4878 6.35736 17.4878C5.38119 17.4878 4.58984 18.2791 4.58984 19.2553V23.0275C4.58984 24.0037 5.38119 24.795 6.35736 24.795C7.33353 24.795 8.12487 24.0037 8.12487 23.0275V19.2553Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M27.3077 25.7663C27.3077 26.7425 28.0991 27.5338 29.0753 27.5338C30.0514 27.5338 30.8428 26.7425 30.8428 25.7663V16.3471C30.8428 15.3709 30.0514 14.5796 29.0753 14.5796C28.0991 14.5796 27.3077 15.3709 27.3077 16.3471V25.7663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M34.8751 22.909C34.8751 23.8852 35.6665 24.6765 36.6426 24.6765C37.6188 24.6765 38.4102 23.8852 38.4102 22.909V19.1368C38.4102 18.1606 37.6188 17.3693 36.6426 17.3693C35.6665 17.3693 34.8751 18.1606 34.8751 19.1368V22.909Z",
    fill: "white"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_461_2736",
    x1: 3,
    y1: 22,
    x2: 45,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B200F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D19A0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_461_2736"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -2,
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSynthiaiChat);
export default __webpack_public_path__ + "static/media/synthiai-chat.a6df8c1bfb7be1b10e504c94319f2e12.svg";
export { ForwardRef as ReactComponent };